var map = {
	"./fastapi.svg": 4550,
	"./gaussian.png": 7005,
	"./multiwfn.png": 2970,
	"./mysql.svg": 3176,
	"./redis.svg": 8563,
	"./sklearn.svg": 2585,
	"./vue.svg": 9275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 309;